// extracted by mini-css-extract-plugin
module.exports = {"root":"PhotoGrid_root__X9iCu","linkImage":"PhotoGrid_linkImage__OGfTa","image":"PhotoGrid_image__aNqNo","reveal-media":"PhotoGrid_reveal-media__giAZw"};